/* eslint-disable no-useless-escape */
import zxcvbn from 'zxcvbn'

import {
  WEAK_PASSWORD_STATUS,
  OKAY_PASSWORD_STATUS,
  STRONG_PASSWORD_STATUS,
} from '~/components/ui/PasswordField/constants'

const LOWER_CASE_LETTERS_REGEX = /[a-z]/g
const CAPITAL_CASE_LETTERS_REGEX = /[A-Z]/g
const NUMBERS_REGEX = /[0-9]/g
const SOME_SYMBOLS_REGEX = /[@#$%&*()-/:-?{-~!"^_`\[\]]/

export const getPasswordStatus = (value, minStrength, thresholdLength) => {
  const strength = zxcvbn(value).score

  const isPasswordWeak = strength < minStrength
  const isPasswordOkay = strength === minStrength
  const isPasswordStrong = strength > minStrength

  const passwordLength = value.length
  const isPasswordLong = passwordLength > thresholdLength

  if (!value) return ''
  if (isPasswordWeak || !isPasswordLong) return WEAK_PASSWORD_STATUS
  if (isPasswordOkay) return OKAY_PASSWORD_STATUS
  if (isPasswordStrong) return STRONG_PASSWORD_STATUS
  return ''
}

export const capitalize = string => string.charAt(0).toUpperCase() + string.slice(1)

export const validateLowerCaseLetters = password => password.match(LOWER_CASE_LETTERS_REGEX)
export const validateCapitalCaseLetters = password => password.match(CAPITAL_CASE_LETTERS_REGEX)
export const validateNumbers = password => password.match(NUMBERS_REGEX)
export const validateSymbols = password => password.match(SOME_SYMBOLS_REGEX)
export const validatePasswordLength = (password, thresholdLength = 8) => password.length >= thresholdLength

export const validatePassword = (password, thresholdLength = 8) => {
  const hasLowerCaseLetters = validateLowerCaseLetters(password)
  const hasCapitalCaseLetters = validateCapitalCaseLetters(password)
  const hasNumbers = validateNumbers(password)
  const hasSymbols = validateSymbols(password)
  const isLongEnough = validatePasswordLength(password, thresholdLength)

  return Boolean(hasLowerCaseLetters && hasCapitalCaseLetters && hasNumbers && hasSymbols && isLongEnough)
}

export const PASSWORD_REQUIREMENTS = [
  { key: 'length', message: 'At least 8 characters in length', validate: validatePasswordLength },
  { key: 'uppercase', message: 'At least one uppercase letter', validate: validateCapitalCaseLetters },
  { key: 'lowercase', message: 'At least one lowercase letter', validate: validateLowerCaseLetters },
  { key: 'numbers', message: 'At least one number', validate: validateNumbers },
  { key: 'symbols', message: 'At least one symbol', validate: validateSymbols },
]

export const getIconColor = isValidRequirement => (isValidRequirement ? '#004BFF' : '#929FA9')
